import { Injectable } from "@angular/core";
import { SignalStore, SignalStoreConfig } from ".";

export interface ThemeStoreModel {
  theme: "system" | "light" | "dark";
}

export const themeStoreConfig: SignalStoreConfig<ThemeStoreModel> = {
  syncStorage: true,
  initState: {
    theme: "system",
  },
  equal: (stateA, stateB) => stateA.theme === stateB.theme,
};

/**
 * Theme store service managing the theme state based on ThemeStoreModel.
 */
@Injectable({
  providedIn: "root",
})
export class ThemeStore {
  private themeStore = new SignalStore<ThemeStoreModel>(
    "theme",
    themeStoreConfig,
  );

  /**
   * Retrieves the current theme state from the theme store.
   * @returns A signal representing the theme state.
   */
  getTheme() {
    return this.themeStore.select((store) => store.theme);
  }

  /**
   * Toggles the theme state in the theme store.
   */
  setTheme(theme: "system" | "light" | "dark") {
    this.themeStore.update((state) => ({
      ...state,
      theme,
    }));
  }
}
